import { NavLink } from "react-router-dom";

const DataTable = ({ voidReasons, handleDelete }) => {

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="text-left" width="20%">Category</th>
                    <th className="text-left">Reasons</th>
                    <th className="text-left" width="1%"/>
                    <th className="text-left" width="1%"/>
                </tr>
            </thead>
            <tbody>
                {voidReasons.map(voidReason => 
					<tr key={voidReason.id}>
						<td>{voidReason.category}</td>
						<td>{voidReason.reason}</td>
						<td className="text-right">
							<NavLink to={`/data/void-reasons/${voidReason.id}`} className="btn btn-primary btn-icon">
                                <span className="las la-pen" />
                            </NavLink>
                        </td>
						<td className="text-right">
							<button className="btn btn-danger btn-icon" onClick={() => handleDelete(voidReason)}>
                                <span className="las la-trash-alt" />
                            </button>
						</td>
					</tr>
				)}
            </tbody>
        </table>
    );
}
 
export default DataTable;